import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, ControlContainer, NgForm, NgModel } from '@angular/forms';
import { CallAPIService } from '../../../services/call-api.service';
import { City } from '../../../interfaces/city.interface';
import { CityInputValidationService } from '../../../services/city-input-validation.service';
import { CloseDropdownService } from '../../../services/close-dropdown.service';
import { MatchCities } from '../../../interfaces/match-cities.interface';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
//import { Location } from '@angular/common';
import { WhatToClear } from '../../../interfaces/what-to-clear.interface';



@Component({
  selector: 'form-city-input',
  styleUrls: ['form-city-input.component.scss'],
  template: `
  <input
  type="text"
  id="toWhere"
  name="c2y"
  class="routeInputs"
  placeholder="Введіть населений пункт та виберіть зі списку"
  (keyup)="onKey($event)"
  (blur)="onBlurMethod( $event )"
  [(ngModel)]="cityValue"
  minlength="2"
  autocomplete="off"
  > 
  
  `,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FormInputCityComponent implements OnInit {


  value: string;
  closeCitiesByName: Array<City> = [];
  prefixForCloseCities: string;
  inputId: string;
  validCityName: boolean = false;
  previousPrefix: string = '';
  lastUserInputTime;
  lastTimeout;
  lastCityPrefix: string;
  delayBtwUserInputAndRequest = 2300;
  cityValue: string;

  @Input('form') form: NgForm;
  @Input('cityName') cityNameFromSelect: BehaviorSubject<City>;
  @Output('inputValue') inputValue: BehaviorSubject<string> = new BehaviorSubject(undefined);
  @Output('newValue') newValue: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(
    private activeRoute: ActivatedRoute,
    private apiService: CallAPIService,
    private cityValidation: CityInputValidationService,
    private closeDropdown: CloseDropdownService,
    private postageInfo: CityInputValidationService,
    private router: Router,
    //private location: Location,
    //private extras: NavigationExtras

  ) {


    let queryParamValue = this.activeRoute.snapshot.queryParamMap.get('city-name')

    this.cityValue = queryParamValue;
    this.checkNewValue(queryParamValue)

  }

  ngOnInit() {

    this.inputId = 'toWhere';
    this.prefixForCloseCities = '';
    this.apiService.addInputCityToSubscribers(this.inputId);

    this.apiService.getObservableCityByInputID(this.inputId).subscribe((response: MatchCities) => {
      if (response.controlID != undefined) {
        if (response.citiesCount == 0) {
          this.cityValidation.setInvalid(this.inputId, 'no cities with prefix: ' + response.cityPrefix);
        }

        if (response.cities && response.cities.length == 1 && this.cityValue) {
          if (this.cityValue.toLocaleLowerCase() == response.cities[0].CITY_UA.toLocaleLowerCase()) {
            // valid
            // was
            this.cityValue = response.cities[0].CITY_UA //  response.cities[0].SHORTCITYTYPE_UA+". "+ 

          }// city name and city response are mach
        }// if response

      }// control ID != undefined
    })// sebscribe city


    this.cityNameFromSelect.subscribe((newCity) => {
      if (newCity != undefined) {
        ////console.log( 'cityNameFromSelect call setCity Name by Obj')
        this.setCityName(newCity);

      }
    })


    // !!!!!!!!!!  QUERY !!!!!!!!!!!!!! 
    let queryParamValue = this.activeRoute.snapshot.queryParamMap.get('city-name');
    ////console.log( 'quer param', queryParamValue  )
    this.cityValue = queryParamValue;
    this.checkNewValue(queryParamValue);

  }

  private setCityName(cityObj: City) {

    if (cityObj != undefined) {
      this.cityValue = cityObj.CITY_UA; // cityObj.SHORTCITYTYPE_UA+" "+

    }

  }


  private getTimeSinceLastUserInput() {
    let now = new Date();
    let differenceTime = -1;
    if (this.lastUserInputTime) {
      differenceTime = now as unknown as number - this.lastUserInputTime as unknown as number;
      // differenceTime /= 1000; 
    }
    this.lastUserInputTime = now;
    return differenceTime;
  }

  onKey(event) { // without type info
    const currentCityPrefix = event.target.value

    if (this.lastCityPrefix && currentCityPrefix && this.lastCityPrefix.length != currentCityPrefix.length || !currentCityPrefix)
      this.newValue.next(null);

    this.lastCityPrefix = event.target.value;

    let value = event.target.value.substring(event.target.value.indexOf('.') + 1)
    //console.log( '>>> ',event.target.value , event.target.value.substring( event.target.value.indexOf('.') + 1  ) )

    this.closeDropdown.closeDropdown('toWhere');
    this.inputValue.next(value);

    if (this.lastTimeout != undefined) {
      clearTimeout(this.lastTimeout);
    } else {
      //console.log( " timer undefined ")
    }

    this.lastTimeout = setTimeout(() => {

      if (value != this.previousPrefix) {
        let clearConfig = this.apiService.buildClearConfig(true, true, true, true, true);
        this.apiService.executeClearWithConfig(clearConfig);


      }

      this.checkNewValue(value);

    }, this.delayBtwUserInputAndRequest - this.getTimeSinceLastUserInput())



  }



  onBlurMethod(event) {
    let value = event.target.value.substring(event.target.value.indexOf('.') + 1)

    if (value != this.previousPrefix) {
      let clearConfig = this.apiService.buildClearConfig(true, true, true, true, true);
      this.apiService.executeClearWithConfig(clearConfig);


    }

    this.checkNewValue(value);

  }

  private checkNewValue(newPrefix: string) { //newPrefix

    newPrefix = newPrefix ? newPrefix.substring(newPrefix.indexOf('.') + 1).trim() : '';
    this.prefixForCloseCities = newPrefix;

    if (this.prefixForCloseCities && this.prefixForCloseCities.length > 1 && (this.prefixForCloseCities != this.previousPrefix) && this.apiService.isContainOnlyUkrainianLatters(this.prefixForCloseCities)) {

      this.apiService.sendRequestForCitiesByPrefix(this.prefixForCloseCities);
      this.previousPrefix = this.prefixForCloseCities;

    }

  }

  public setNewValue(newValue: string) {
    newValue = newValue.substring(newValue.indexOf('.') + 1)
    this.checkNewValue(newValue);

  }

  public getValue() {
    return this.prefixForCloseCities;
  }

}
